export function getInventoryStages(payload = {}, includeArchived = false) {
	const stages = payload?.stagedWorksheet?.stages || []
	return includeArchived ? [...stages, ...(payload?.stagedWorksheet?.archivedStages || []).map(stage => ({...stage, title: `${stage.title} (removed level)`}))] : stages
}

export function getInventoryItems(payload = {}) {
	return getInventoryStages(payload).flatMap(stage => (stage.items || []).map(item => ({...item, stage})))
}

export function groupInventoryItems(payload = {}, config = {}) {
	const groups = new Map()
	const snapshot = payload.stagedWorksheet?.choiceOptionSnapshot || []
	for (let stage of getInventoryStages(payload, true)) {
		for (let item of stage.items || []) {
			if (!item.text && !Object.values(item.values || {}).some(hasInventoryValue)) continue
			const ids = [...new Set(item.values?.choices || [])]
			const key = [...ids].sort().join('|')
			const order = [...(config.choiceOptions || []), ...snapshot].map(option => option.value)
			const orderedIds = [...ids].sort((left, right) => order.indexOf(left) - order.indexOf(right))
			if (!groups.has(key)) groups.set(key, {id: key || 'uncharacterized', title: choiceLabels(config.choiceOptions, orderedIds, snapshot).join(' + ') || 'Not characterized', items: []})
			groups.get(key).items.push({...item, stage})
		}
	}
	return [...groups.values()]
}

export function optionLabel(options = [], id = "", snapshot = []) {
	if (!id) return "Not recorded"
	return options.find(option => option.value === id)?.label || (snapshot.find(option => option.value === id)?.label ? `Removed: ${snapshot.find(option => option.value === id).label}` : "Removed option")
}

export function choiceLabels(options = [], ids = [], snapshot = []) {
	return (Array.isArray(ids) ? ids : []).map(id => optionLabel(options, id, snapshot))
}

export function inventoryFields(config = {}, payload = {}, item = {}) {
	const current = config.entryFields || []
	const knownIds = new Set(current.map(field => field.id))
	const archived = (payload.stagedWorksheet?.entryFieldSnapshot || []).filter(field => !knownIds.has(field.id) && hasInventoryValue(item.values?.[field.id])).map(field => ({...field, title: `Removed question: ${field.title}`}))
	return [...current, ...archived]
}

export function hasInventoryValue(value) {
	return value !== null && value !== undefined && value !== "" && (!Array.isArray(value) || value.length > 0)
}


export function getStagedWorksheetInventoryView(payload = {}, config = {}) {
	const groups = groupInventoryItems(payload, config).map(group => ({
		...group,
		items: group.items.map(item => createInventoryItemView(item, payload, config)),
	}))
	const stages = getInventoryStages(payload).map(stage => ({...stage, items: (stage.items || []).filter(item => item.text || Object.values(item.values || {}).some(hasInventoryValue))}))
	return {groups, stages}
}

function createInventoryItemView(item, payload, config) {
	const fields = inventoryFields(config, payload, item)
	const answeredFields = {}
	for (const field of fields) {
		if (!hasInventoryValue(item.values?.[field.id])) continue
		const source = field.source || "reported"
		;(answeredFields[source] ||= []).push(field)
	}
	const unresolvedLinks = (config.entryFields || []).filter(field => field.role === "presentingLink" && !hasInventoryValue(item.values?.[field.id]))
	const periodLabel = optionLabel(config.periodOptions, item.values?.period, payload.stagedWorksheet?.periodOptionSnapshot)
	return {...item, fields, answeredFields, unresolvedLinks, periodLabel}
}
